import { useNavigate } from 'react-router';
import { useCustomers } from '@t90/api-client';
import { DataTable, Button, Badge, Plus } from '@t90/ui';
import { formatDate } from '@t90/common';
import type { ColumnDef } from '@tanstack/react-table';
import type { Customer } from '@t90/common';

const columns: ColumnDef<Customer>[] = [
  {
    accessorKey: 'customer_name',
    header: 'Company',
    cell: ({ row }) => (
      <span className="font-medium">{row.getValue('customer_name')}</span>
    ),
  },
  {
    accessorKey: 'contact_name',
    header: 'Contact Name',
  },
  {
    accessorKey: 'contact_email',
    header: 'Email',
  },
  {
    accessorKey: 'contact_phone',
    header: 'Phone',
  },
  {
    accessorKey: 'active',
    header: 'Status',
    cell: ({ row }) => {
      const active = row.getValue('active') as boolean;
      return (
        <Badge variant={active ? 'success' : 'secondary'}>
          {active ? 'Active' : 'Inactive'}
        </Badge>
      );
    },
  },
  {
    accessorKey: 'created_at',
    header: 'Created',
    cell: ({ row }) => formatDate(row.getValue('created_at')),
  },
];

export function CustomersPage() {
  const navigate = useNavigate();
  const { data: customers, isLoading } = useCustomers();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Customers</h1>
          <p className="text-muted-foreground">
            Manage customer accounts and contacts
          </p>
        </div>
        <Button onClick={() => navigate('/customers/new')}>
          <Plus className="mr-2 h-4 w-4" />
          Add Customer
        </Button>
      </div>

      <DataTable
        columns={columns}
        data={customers ?? []}
        searchKey="customer_name"
        searchPlaceholder="Search customers..."
        isLoading={isLoading}
        onRowClick={(row) => navigate(`/customers/${row.id}`)}
        emptyMessage="No customers found."
      />
    </div>
  );
}
